import React, { useEffect, useState, useRef } from "react";
import { RenderMarkdownWithLatex } from "../../utils/utils"; // Upewnij się, że ścieżka jest poprawna
import PageTestPage from "../molecules/PageTestPage"; // Upewnij się, że ścieżka jest poprawna
import Confetti from "react-confetti";

// --- PRZYKŁADOWE DANE ZADANIA ---
const mockProblem = {
  problem_id: 101,
  field_id: "alg-1",
  question: "Ile wynosi wartość wyrażenia $$\\log_2(8) + \\log_3(9)$$?",
  image_link: null, 
  true_answer: "5",
  false_answer1: "4",
  false_answer2: "6",
  false_answer3: "$\\log_5(17)$",
  hint: "Przypomnij sobie definicję logarytmu: $\\log_a(b) = c \\iff a^c = b$.",
  solution: "Obliczamy każdy logarytm osobno:\n1. $\\log_2(8) = 3$, ponieważ $2^3 = 8$.\n2. $\\log_3(9) = 2$, ponieważ $3^2 = 9$.\n\nSuma wynosi $3 + 2 = 5$.",
  problem_elo: 1250,
  user_elo: 1200,
  points_assigned: 2,
  linked_matura_problems: [ { source: "CKE Maj 2023, zad. 5" } ],
  linked_formulas: [
    { 
        matura_formula_match_id: 1,
        name: "Definicja logarytmu", 
        text: "Dla $a>0, a \\neq 1, b>0$ mamy $\\log_a b = c \\iff a^c=b$."
    },
    {
        matura_formula_match_id: 2,
        name: "Twierdzenie Pitagorasa",
        text: "W trójkącie prostokątnym o przyprostokątnych $a, b$ i przeciwprostokątnej $c$ zachodzi związek: $a^2 + b^2 = c^2$."
    }
  ]
};
// --- KONIEC PRZYKŁADOWYCH DANYCH ---

const useWindowSize = () => {
  const [size, setSize] = useState([window.innerWidth, window.innerHeight]);
  useEffect(() => {
    const handleResize = () => setSize([window.innerWidth, window.innerHeight]);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return { width: size[0], height: size[1] };
};

const SolveProblemDes = () => {
  const { width, height } = useWindowSize();

  const [currentProblem] = useState(mockProblem);
  const [answers, setAnswers] = useState([]);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const [isAnswerChecked, setIsAnswerChecked] = useState(false);
  const [isHintUsed, setIsHintUsed] = useState(false);
  const [showSolution, setShowSolution] = useState(false);
  const [showConfetti, setShowConfetti] = useState(false);
  
  useEffect(() => {
    const problemAnswers = [
      { text: currentProblem.true_answer, isCorrect: true },
      { text: currentProblem.false_answer1, isCorrect: false },
      { text: currentProblem.false_answer2, isCorrect: false },
      { text: currentProblem.false_answer3, isCorrect: false },
    ].filter(ans => ans.text != null && ans.text !== '');

    setAnswers(problemAnswers.sort(() => Math.random() - 0.5));
  }, [currentProblem]);

  const handleAnswerClick = (answer) => {
    if (isAnswerChecked) return;
    setSelectedAnswer(answer);
    setIsAnswerChecked(true);
    if (answer.isCorrect) {
      setShowConfetti(true);
      setTimeout(() => setShowConfetti(false), 5000);
    } else {
      setShowSolution(true);
    }
  };

  const handleSolution = () => setShowSolution(true);
  const handleHint = () => setIsHintUsed(true);
  const handleNextProblem = () => {
    setIsAnswerChecked(false);
    setSelectedAnswer(null);
    setIsHintUsed(false);
    setShowSolution(false);
    setShowConfetti(false);
    alert("Przechodzę do następnego zadania! (To jest zaślepka)");
  };
  const handleEndSession = () => alert("Kończę sesję! (To jest zaślepka)");

  const renderUserProblemElo = () => (
      <div className="flex flex-col items-center mb-4">
        <h2 className="text-sm font-semibold text-gray-500 tracking-wide mb-2">
          Zadanie 1, Id: {currentProblem.problem_id}
        </h2>
        <div className="grid grid-cols-[1fr_auto_1fr] items-center w-full max-w-md">
          <div className="flex flex-col items-center"><div className="text-2xl font-bold text-blue-600">{currentProblem.user_elo}</div><span className="text-xs text-gray-500">Twoje ELO</span></div>
          <div className="text-sm text-gray-500 text-center">vs.</div>
          <div className="flex flex-col items-center"><div className="text-2xl font-bold text-blue-600">{currentProblem.problem_elo}</div><span className="text-xs text-gray-500">ELO Zadania</span></div>
        </div>
        <p className="mt-2 text-[1.06rem] font-light text-gray-900 text-center pt-1">
          <RenderMarkdownWithLatex text={`(${currentProblem.points_assigned} pkt) ${currentProblem.question}`} />
        </p>
        {currentProblem.linked_matura_problems?.length > 0 && (
          <div className="mt-1 w-full text-center text-[0.65rem] text-gray-500 italic px-2 leading-tight">
            Na podstawie: {currentProblem.linked_matura_problems.map(p => p.source).join(', ')}
          </div>
        )}
      </div>
  );

  const renderAnswers = () => (
      <div className="grid grid-cols-2 gap-3 w-full">
        {answers.map((answer, index) => {
          const isCorrectAndChecked = isAnswerChecked && answer.isCorrect;
          const isIncorrectSelected = isAnswerChecked && !answer.isCorrect && selectedAnswer?.text === answer.text;
          return (
            <button
              key={index}
              onClick={() => handleAnswerClick(answer)}
              disabled={isAnswerChecked}
              className={`flex items-center justify-center rounded-lg bg-blue-100 px-4 py-2 text-base font-normal shadow-sm transition-all duration-200 ${
                isCorrectAndChecked ? "bg-green-100 text-green-700" :
                isIncorrectSelected ? "bg-red-100 text-red-700" :
                "hover:bg-blue-200"
              }`}
            >
              <RenderMarkdownWithLatex text={answer.text} />
            </button>
          );
        })}
      </div>
  );
  
  // --- FUNKCJA RENDERUJĄCA HINT - DOKŁADNIE TAKA JAK W ORYGINALE ---
  const renderHintSection = () => {
    const problem = currentProblem;
    if (!problem) return null;

    const hasActualHint = problem.hint && problem.hint.trim() !== "";
    const hasLinkedFormulas = problem.linked_formulas && problem.linked_formulas.length > 0;

    if (!hasActualHint && !hasLinkedFormulas) {
        return <div className="w-full"></div>;
    }

    return (
      <div className="w-full">
        {isHintUsed ? (
          <div className="bg-gray-50 px-3 py-2 rounded shadow-md text-sm">
            {hasActualHint && (
              <div>
                {hasLinkedFormulas && <h4 className="font-semibold text-gray-600 mb-1">Podpowiedź:</h4>}
                <RenderMarkdownWithLatex text={problem.hint} />
              </div>
            )}
            {hasLinkedFormulas && (
              <div className={hasActualHint ? "mt-3 pt-3 border-t border-gray-200" : ""}>
                <div className='font-semibold text-gray-600 mb-2'>Wzory z Karty Wzorów CKE:</div>
                <div className="space-y-2">
                  {problem.linked_formulas.map((formula, idx) => {
                    return (
                      <div key={formula.matura_formula_match_id || `formula-${idx}`}
                           className="p-2 mb-1 ">
                        {formula.name && (
                          <p className="text-sm font-medium text-gray-700">
                            <RenderMarkdownWithLatex text={formula.name} />
                          </p>
                        )}
                        {formula.text && (
                          <div className="text-xs text-gray-600 mt-1 pl-2 border-l-2 border-gray-300">
                            <RenderMarkdownWithLatex text={formula.text} />
                          </div>
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        ) : (
          <div
            onClick={handleHint}
            className="bg-gray-50 px-3 py-2 rounded shadow-md text-xs text-gray-600 text-center cursor-pointer"
          >
            Podpowiedź
          </div>
        )}
      </div>
    );
  };

  const renderSolutionSection = () => {
    if (!isAnswerChecked && !showSolution) {
        return (
            <div className="w-full">
                <div onClick={handleSolution} className="bg-gray-100 hover:bg-gray-200 px-4 py-2 rounded-lg shadow-sm text-sm text-center text-gray-800 cursor-pointer">
                    Rozwiązanie
                </div>
            </div>
        )
    }
    if (isAnswerChecked || showSolution) {
       return (
        <div className="w-full">
            <div className="bg-gray-50 p-4 rounded-lg shadow-md text-sm">
              <h3 className="font-semibold text-gray-700 mb-2">Rozwiązanie</h3>
              <RenderMarkdownWithLatex text={currentProblem.solution} />
            </div>
        </div>
      );
    }
    return null;
  }
  
  const renderSessionStatus = () => (
      <div className="mt-4 w-full overflow-hidden">
          <div className="flex flex-nowrap gap-1 justify-center">
              <div className="flex justify-center items-center w-6 h-6 border-2 rounded text-xs text-black shrink-0 border-green-600">1</div>
              <div className="flex justify-center items-center w-6 h-6 border-2 rounded text-xs text-black shrink-0 border-red-600">2</div>
              <div className="flex justify-center items-center w-6 h-6 border-2 rounded text-xs text-black shrink-0 border-green-600">3</div>
          </div>
      </div>
  )

  return (
    <PageTestPage showNav={true} reportIssueData={{ problem_id: currentProblem.problem_id }}>
      {showConfetti && <Confetti width={width} height={height} recycle={false} />}

      <div className="flex flex-col items-center px-4 py-4 space-y-4">
        {renderUserProblemElo()}
        
        {renderHintSection()}
        
        {renderAnswers()}
        
        {renderSolutionSection()}

        {isAnswerChecked ? (
          <>
            <div className="w-full pt-2">
              <button onClick={handleNextProblem} className="flex w-full justify-center rounded-md bg-blue-600 px-3 py-1.5 text-sm font-semibold text-white shadow-sm hover:bg-blue-500">
                Kolejne zadanie
              </button>
            </div>
            {renderSessionStatus()}
          </>
        ) : (
          renderSessionStatus()
        )}
      </div>
    </PageTestPage>
  );
};

export default SolveProblemDes;